import axios from 'axios';

export default {
       
    getBanners (windowWidth , itemSectionId) {
        return axios.get('/api/banner/list',{ params: {windowWidth: windowWidth , itemSectionId:itemSectionId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },
}